import React, { useState, useEffect, useContext } from 'react'
import Button from '@mui/material/Button'
import Grid from '@mui/material/Grid'
import { UsuarioInterface } from '../../ImportBackend/Interfaces/UsuarioInterfaces'
import Condicional from '../../Layout/Condicional'
import { StatusForm } from './Sistema/Usuarios'
import CloseIcon from '@mui/icons-material/Close'
import ShowText from '../../DevComponents/ShowText'
import { UnidadeInterface } from '../../ImportBackend/Interfaces/UnidadeInterfaces'
import BackEndAPI from '../../Services/BackEndAPI'
import { ContextoGlobal, ContextoGlobalInterface } from '../../GlobalStates/ContextoGlobal'
import { MensagemTipo } from '../../GlobalStates/MensagemState'
import DataTable, { DataTableCabecalhoInterface } from '../../DevComponents/DataTable'
import SearchText from '../../DevComponents/SearchText'
import { RespostaPadraoInterface } from '../../ImportBackend/Interfaces/PadraoInterfaces'
import Typography from '@mui/material/Typography'

interface PropsInterface {
  statusForm: StatusForm
  dados: UsuarioInterface
  clsApi: BackEndAPI
  onCancelar: () => void
}

export default function UsuariosUnidades ( { clsApi, statusForm, dados, onCancelar }: PropsInterface ) {

  const [rsUnidades, setRsUnidades] = useState<Array<UnidadeInterface>>( [] )

  const contexto = useContext( ContextoGlobal ) as ContextoGlobalInterface
  const { mensagemState, setMensagemState } = contexto

  const Cabecalho: Array<DataTableCabecalhoInterface> = [
    {
      campo: 'descricao',
      cabecalho: 'Descrição',
      alinhamento: 'left'
    }
  ]

  const btExcluirUnidade = ( grupo: UnidadeInterface ) => {

    const mutation = `
        excluirUnidadeUsuario(idUsuario: ${dados.idUsuario}, idUnidade: ${grupo.idUnidade}) {
          ok
          mensagem
        }
      `

    clsApi.mutation<RespostaPadraoInterface>( mutation, 'excluirUnidadeUsuario', 'Excluindo Unidade...', contexto ).then( rs => {

      if ( rs.ok ) {

        pesquisarUsuarioUnidades()

      } else {

        setMensagemState( {
          ...mensagemState,
          exibir: true,
          mensagem: rs.mensagem,
          tipo: MensagemTipo.Error,
          exibirBotao: true
        } )

      }

    } )

  }

  const abortController: AbortController = new AbortController()

  const pesquisarUsuarioUnidades = () => {
    const query = `
      getUsuarioUnidadesPermitidasPorIdUsuario(idUsuario: ${dados.idUsuario}) {
        idUnidade
        descricao
      }
    `

    clsApi.query<Array<UnidadeInterface>>( query, 'getUsuarioUnidadesPermitidasPorIdUsuario', 'Recebendo Unidades...', contexto, abortController ).then( rsUnidades => {
      setRsUnidades( rsUnidades )

    } ).catch( () => {

      setMensagemState( {
        ...mensagemState,
        titulo: 'Erro! Consulte Suporte!',
        exibir: true,
        mensagem: 'Erro ao Consultar Unidades de Usuários!',
        tipo: MensagemTipo.Error,
        exibirBotao: true
      } )

    } )
  }

  useEffect( () => {

    if ( [StatusForm.EditandoUnidades].includes( statusForm ) ) {

      pesquisarUsuarioUnidades()

    }

    return () => {

      abortController.abort()

    }

    //eslint-disable-next-line
  }, [dados, statusForm] )

  const [novoUnidade, setNovoUnidade] = useState<UnidadeInterface | null>( null )

  const novoUnidadeSelecionado = ( v: UnidadeInterface | null ) => {

    setNovoUnidade( v )

    if ( v ) {

      const mutation = `
        incluirUnidadeUsuario(idUsuario: ${dados.idUsuario}, idUnidade: ${v.idUnidade}) {
          ok
          mensagem
        }
      `

      clsApi.mutation<RespostaPadraoInterface>( mutation, 'incluirUnidadeUsuario', 'Incluindo Unidade...', contexto ).then( rs => {

        if ( rs.ok ) {

          pesquisarUsuarioUnidades()

        } else {

          setMensagemState( {
            ...mensagemState,
            exibir: true,
            mensagem: rs.mensagem,
            tipo: MensagemTipo.Error,
            exibirBotao: true
          } )

        }

      } )

    }

  }

  return (
    <>
      <Condicional condicao={[StatusForm.EditandoUnidades].includes( statusForm )}>
        <Grid item xs={12}>
          <ShowText dados={dados} field='nome' label='Nome' />
        </Grid>

        <Condicional condicao={dados.usuarioMatriz}>
          <Grid item xs={12}>
            <Typography component="h6" variant="h6" align="center" sx={{ mt: 5 }}>
              Usuário Matriz com Acesso a todas as unidades.
            </Typography>
          </Grid>

        </Condicional>
        <Condicional condicao={!dados.usuarioMatriz}>

          <Grid item xs={12}>

            <SearchText
              onChange={novoUnidadeSelecionado}
              objQuery='{idUnidade, descricao}'
              campoPesquisa='descricao'
              campoID='idUnidade'
              label='Adicionar Unidade'
              value={novoUnidade}
              mensagemQuery='Procurando Unidades...'
              campoQuery='pesquisa'
              nomeQuery='getUnidades'
            />

          </Grid>

          <Grid item xs={12} sx={{ mt: 3 }}>

            <Typography component="h6" variant="h6" align="left">
              Unidades Ativas Para Este Usuário
            </Typography>

            <DataTable
              dados={rsUnidades}
              cabecalho={Cabecalho}
              acoes={[{ icone: 'delete', toolTip: 'Cancelar Permissão', onAcionador: btExcluirUnidade }]}
            />

          </Grid>

        </Condicional>

        <Grid item xs={12} sx={{ mt: 3, textAlign: 'right' }}>

          <Button variant='contained' startIcon={<CloseIcon />} sx={{ py: 1 }} onClick={() => onCancelar()}>Cancelar</Button>

        </Grid>

      </Condicional>
    </>
  )

}